var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.361 11.358C75.1706 25.1653 75.1706 47.5523 61.361 61.3607C47.5526 75.1714 25.1644 75.1714 11.3572 61.3607C-2.45239 47.5535 -2.45239 25.1664 11.3572 11.358C25.1644 -2.45267 47.5515 -2.45267 61.361 11.358Z",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2179 14.6875H32.9366V59.1719H35.2179V14.6875Z",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7804 14.6875H37.4991V59.1719H39.7804V14.6875Z",
    fill: "#D6D6D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6105 26.0938C46.6105 26.0938 46.6105 19.25 36.3448 19.25C26.0792 19.25 27.2198 27.2344 27.2198 27.2344C27.2198 27.2344 27.2198 35.2188 36.3448 35.2188C46.6105 35.2188 47.7648 42.0625 47.7648 43.2031C47.7648 45.4844 48.8917 52.3281 36.3448 52.3281C26.0792 52.3281 26.0929 47.7656 26.0929 46.625",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.ff6db13249319a98ab54ba902813b626.svg";
export { ForwardRef as ReactComponent };